import { useQuery, gql } from '@apollo/client';
import { CurrentSubscription, PaymentSource } from '../types';
import toast from 'helpers/toast';

type PaymentSourceInfoQueryResult = {
  viewer: {
    id: string;
    billing: {
      subscription: CurrentSubscription;
    };
  };
};

const PAYMENT_SOURCE_INFO_QUERY = gql`
  query PaymentSourceInfo {
    viewer {
      id
      billing {
        subscription {
          id
          paymentSource {
            brand
            expMonth
            expYear
            last4
            paymentMethod
            bankName
          }
        }
      }
    }
  }
`;

const usePaymentSourceInfoQuery = () => {
  const { loading, data } = useQuery<PaymentSourceInfoQueryResult>(
    PAYMENT_SOURCE_INFO_QUERY,
    {
      onError: () => {
        toast.error('billing.stripePaymentModal.paymentMethodFailed');
      },
    },
  );
  const paymentSource: PaymentSource =
    data?.viewer?.billing?.subscription?.paymentSource;

  return { loading, paymentSource };
};

export default usePaymentSourceInfoQuery;
